import { Anchor } from '@zillow/constellation-10';
import emailUtils from '../utils/emailUtils';

export const ERROR_PAGE_TYPES = {
  NOT_FOUND: 'not-found',
  TECHNICAL_DIFFICULTIES: 'technical-difficulties',
  UNAUTHORIZED: 'unauthorized',
  PREMIUM_ANALYTICS_ERROR: 'premium-analytics-error',
} as const;

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Refresh the page and try again.';

const streetEasyUrl = 'https://streeteasy.com/nyc/submit_your_listings';
const learnMoreUrl =
  'http://www.zillow.com/rental-property-advertising?utm_medium=referral&utm_content=learnmorelink' +
  '&utm_source=zrm&utm_campaign=zrm_add_property';

export const ErrorMessageConstants = {
  LOCATION_RESTRICTION: {
    NYC: [
      'This listing can’t be published. Please visit ',
      <a href={streetEasyUrl} target="_blank" rel="noopener noreferrer">
        StreetEasy
      </a>,
      ' to list a rental in this area of New York.',
    ],
    MF_REQUIRED: [
      'This address is a 25+ unit apartment community, which requires a Zillow advertising contract. ',
      'For more information, see ',
      <a href={learnMoreUrl} target="_blank" rel="noopener noreferrer">
        here
      </a>,
      '.',
    ],
    DUPLICATE: {
      MESSAGE: 'This property is already posted.',
      LINK_TEXT: 'View Listing',
    },
  },
  SINGLE_FAMILY_NO_ACTIVE_CONTRACT: (
    <span>
      There is no active contract. Contact{' '}
      <Anchor target="_blank" href="mailto:rentalfeedinquiries@zillowgroup.com" rel="noopener noreferrer">
        rentalfeedinquiries@zillowgroup.com
      </Anchor>
      .
    </span>
  ),
  SINGLE_FAMILY_CANNOT_RETRIEVE_CONTRACTS: 'Cannot retrieve active contacts, please try again later.',
  PAID_LISTING_DUPE_ERROR: (isMFSupport = false, isSingleFamilyEnterpriseCustomer = false) => [
    'Another partner has an active listing at this location. ',
    'If you are the owner/manager of this location, please ',
    <a
      href={`mailto:${emailUtils.getHelpEmail(isMFSupport, isSingleFamilyEnterpriseCustomer)}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      contact support
    </a>,
    '.',
  ],
  EXTERNAL_TOUR_INVALID_URL: 'The tour link is invalid.',
  EXTERNAL_TOUR_ALREADY_EXIST: 'This tour link already exists.',
  EXTERNAL_TOUR_NOT_SUPPORTED_PROVIDER: 'This source is not supported.',
  EXTERNAL_TOUR_NO_PERMISSION: (isMFSupport = false, isSingleFamilyEnterpriseCustomer = false) => (
    <span>
      You don’t have access to add external tours. Please reach out to support for help:{' '}
      <Anchor
        target="_blank"
        href={`mailto:${emailUtils.getHelpEmail(isMFSupport, isSingleFamilyEnterpriseCustomer)}`}
        rel="noopener noreferrer"
      >
        {emailUtils.getHelpEmail(isMFSupport)}
      </Anchor>
    </span>
  ),
  LISTING_NO_PERMISSION: `This listing belongs to a different user and you do not have permission to access it. If you believe you should be able to access this listing, make sure you are signed in to the same account that created this listing.`,
  TECHNICAL_DIFFICULTIES: 'Try refreshing the page. If that doesn’t work, check back in a few minutes.',
};
